import React, { useState, useRef } from "react";
import { Card, Col, Container, Row, Modal, Form, FormGroup, Button, Tooltip, OverlayTrigger, Dropdown } from "react-bootstrap";
import { Input, Select, DatePicker } from "antd";
import { Breadcrumb, ImageElement, StoreHeader } from "../../components";
import { Link } from "react-router-dom";
const { TextArea } = Input;

function StoreProfile() {

    const breadcrumb = [
        {
            path: '/dashboard',
            name: 'Home',
        },
    ];
    const Eye=()=>{
        if(password==="password"){
            setpassword("text");
            seteye(false);
        }
        else{
            setpassword("password");
            seteye(true);
        }
    }
    const Eye2=()=>{
        if(password2==="password"){
            setpassword2("text");
            seteye2(false);
        }
        else{
            setpassword2("password");
            seteye2(true);
        }
    }
    const Eye3=()=>{
        if(password3==="password"){
            setpassword3("text");
            seteye3(false);
        }
        else{
            setpassword3("password");
            seteye3(true);
        }
    }
    const[eye,seteye]=useState(true);
    const[password,setpassword]=useState("password");
    const[eye2,seteye2]=useState(true);
    const[password2,setpassword2]=useState("password");
    const[eye3,seteye3]=useState(true);
    const[password3,setpassword3]=useState("password");

    const [show, setShow] = useState(false);
    const [documentModal, setDocumentModal] = useState(false);
    const [promoCodeModal, setPromoCodeModal] = useState(false);
    const [questionModal, setQuestionModal] = useState(false);
    const [profileModal, setProfileModal] = useState(false);
    const [editaddressModal, setEditaddressModal] = useState(false);
    const [editpswModal, setEditpswModal] = useState(false);
    const [bookdetailModal, setBookModal] = useState(false);
    const handleClose = () => { setShow(false); setDocumentModal(false); setPromoCodeModal(false); setQuestionModal(false); setProfileModal(false); setEditaddressModal(false); setEditpswModal(false); setBookModal(false); };
    const handleShow = () => setShow(true);
    const handleShowDocument = () => setDocumentModal(true);
    const handleShowPromo = () => setPromoCodeModal(true);
    const handlequestion = () => setQuestionModal(true);
    const handleprofile = () => setProfileModal(true);
    const handleeditaddress = () => setEditaddressModal(true);
    const handleeditpsw = () => setEditpswModal(true);
    const handlebookdetail = () => setBookModal(true);

    // const [password] = useState("password");
    const [isSwitchOn, setIsSwitchOn] = useState(false);

    const target = useRef(null); 

    return (
      
          
        <>
            <StoreHeader />
            <div className="main-content profilePage profilePage-store">
                {/* page content */}
                <div className="pageContent">
                    <div className="pageContent_wide">
                        <Container>
                            <div className="d-flex justify-content-between">
                                <Breadcrumb className="flex-grow-1 me-2" title="Profile" breadcrumb={breadcrumb} />
                                <div className="dropBtn">
                                    <Link to="#" onClick ={ () => setIsSwitchOn(!isSwitchOn) } className="dropBtn_toggle d-block d-sm-none">
                                        <em className="gg-more-vertical"></em>
                                    </Link>
                                    <div className={"mb-3 mb-sm-0 pb-2 dropBtn_card " + (isSwitchOn ? 'd-block' : '')}>
                                        <div className="d-flex flex-wrap">
                                            <Link to="/promo-code" className="btn btn-primary me-2" ><span className="d-inline-block">View Promo Code</span></Link>
                                            <Link onClick={handleShowPromo} className="btn btn-primary me-2" ><span className="d-inline-block">Add Promo Code</span></Link>
                                            <Link onClick={handlequestion} className="btn btn-primary" ><span className="d-inline-block">Have a Question?</span></Link>
                                        </div>                                        
                                    </div>
                                </div>
                            </div>
                            <div className="profileBox br-10 p-30 bg-white">
                                <div className="d-flex align-items-center profileBox_info">
                                    <div className="position-relative">
                                        <ImageElement source="profile-img.png" alt="user" />
                                        <span onClick={handleprofile} className="upload position-absolute"><em className="text-500 gg-camera" /></span>
                                    </div>
                                    <div className="ms-md-4 ms-2 text-break me-2">
                                        <h2 className="font-md mb-1">Nikola Laringo</h2>
                                        <p className="ft-14 font-md mb-0">nikolalaringo@gmail.com</p>
                                        <p className="ft-14 font-md mb-0">+01  646-562-7924</p>
                                    </div>
                                    <div className="ms-auto">
                                        <Link onClick={handleShow} className="editIcon"><em className="gg-edit" /></Link>
                                    </div>
                                </div>
                                <div className="profileBox_card">
                                    <Row className="justify-content-center">
                                        <Col sm="6" md="4">
                                            <Card>
                                                <Card.Body>
                                                    <div className="d-flex justify-content-between">
                                                        <em className="gg-marker" />
                                                        <Link onClick={handleeditaddress} className="store-editIcon"><em className="gg-edit mb-0 d-inline-block" /></Link>
                                                    </div>
                                                    <Card.Title as="h3" className="font-bd text-uppercase mb-2">Address</Card.Title>
                                                    <Card.Text className="ft-14">Vijay Nagar Square,Indore, Madhya Pradesh, India</Card.Text>
                                                </Card.Body>
                                            </Card>
                                        </Col>
                                        <Col sm="6" md="4">
                                            <Card>
                                                <Card.Body>
                                                    <div className="d-flex justify-content-between">
                                                        <em className="gg-locks" />
                                                        <Link onClick={handleeditpsw} className="store-editIcon"><em className="gg-edit mb-0 d-inline-block" /></Link>
                                                    </div>
                                                    <Card.Title as="h3" className="font-bd text-uppercase mb-2">password</Card.Title>
                                                    <Card.Text className="ft-14">*********</Card.Text>
                                                </Card.Body>
                                            </Card>
                                        </Col>
                                        <Col sm="6" md="4">
                                            <Card>
                                                <Card.Body>
                                                    <div className="d-flex justify-content-between">
                                                        <em className="gg-bank" />
                                                        <Link onClick={handlebookdetail} className="store-editIcon"><em className="gg-edit mb-0 d-inline-block" /></Link>
                                                    </div>
                                                    <Card.Title as="h3" className="font-bd text-uppercase mb-2 d-flex">bank detail
                                                        <div className='toolTip'>
                                                            <OverlayTrigger
                                                                key='top'
                                                                placement='top'
                                                                overlay={
                                                                    <Tooltip id='tooltip-top'>
                                                                        Lorem ipsum dolor sit amet.
                                                                    </Tooltip>
                                                                }
                                                            >
                                                                <Link to="#" ref={target}>
                                                                    <em className="gg-info ft-14 mb-0 ms-1" />
                                                                </Link>
                                                            </OverlayTrigger>

                                                        </div>
                                                    </Card.Title>
                                                    <Card.Text className="ft-14">This is where your monthly direct deposit will go.</Card.Text>
                                                </Card.Body>
                                            </Card>
                                        </Col>
                                    </Row>
                                    <div className="docbox">
                                        <h4 className="font-md">Required Documents</h4>
                                        <p className="ft-14">Payments Over $400 Will Usually Require Us To Verify Your Identity For Our Banking Partner. If Less Than $400 The Bank Usually Does Not Require This. We Will Be Required To Collect Your ID For Anything Above $400.</p>
                                        <div className="docbox_desc">
                                            <Row>
                                                <Col sm="12" md="6">
                                                    <Card>
                                                        <Card.Body>
                                                            <h4 className="font-md">Document Description</h4>
                                                            <p className="mb-0 ft-14">Lorem ipsum dolor sit amet, consectetur adipiscing elit. In congue bibendum mauris. In hac habitasse platea dictumst. Aenean nec ex eget odio efficitur consectetur.</p>
                                                        </Card.Body>
                                                        <Card.Footer className="bg-white"><Link onClick={handleShowDocument} className="btn btn-outline-primary float-end" ><span className="d-inline-block">As Documents</span></Link></Card.Footer>
                                                    </Card>
                                                </Col>
                                            </Row>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </Container>
                    </div>
                </div>
            </div>

            {/* Edit Profile */}
            <Modal show={show} onHide={handleClose} size="lg" centered id="editProfile" backdrop="static">
                <Modal.Header closeButton className="align-items-start">
                    <div>
                        <Modal.Title>Edit Profile</Modal.Title>
                    </div>
                </Modal.Header>
                <Modal.Body>
                    <Form>
                        <Row className="gx-3">
                            <Col sm={12}>
                                <FormGroup className="form-group">
                                    <label className="ant-label">Enter Your Email Id<span className="text-650">*</span></label>
                                    <Input size="large" placeholder="Enter Your Email Id" value="Nikolalaringo@Gmail.Com " />
                                </FormGroup>
                            </Col>
                            <Col sm={12}>
                                <FormGroup className="form-group">
                                    <label className="ant-label">Your Name Or Company Name<span className="text-650">*</span></label>
                                    <Input size="large" placeholder="Enter Your Name Or Company Name" value="Nikolalaringo" />
                                </FormGroup>
                            </Col>
                            <Col sm={6}>
                                <FormGroup className="form-group">
                                    <label className="ant-label">Select Country<span className="text-650">*</span></label>
                                    <Select size="large" className="w-100" placeholder="India"
                                        options={[
                                            {
                                                value: '1',
                                                label: 'India',
                                            },
                                            {
                                                value: '2',
                                                label: 'Srilanka',
                                            },
                                            {
                                                value: '3',
                                                label: 'Test SJ',
                                            },
                                            {
                                                value: '4',
                                                label: 'United States',
                                            }
                                        ]}
                                    />
                                </FormGroup>
                            </Col>
                            <Col sm={6}>
                                <FormGroup className="form-group form-group-number">
                                    <label className="ant-label">Phone Number<span className="text-650">*</span></label>
                                    <div className="position-relative">
                                        <Input size="large" value="1234567890" placeholder="Number" />
                                        <div className="form-cstm position-absolute top-0 left-0 d-flex">
                                            <Select size="large" className="w-100" placeholder="+91"
                                                options={[
                                                    {
                                                        value: 'India',
                                                        label: '+91',
                                                    }
                                                ]}
                                            />
                                        </div>
                                    </div>
                                </FormGroup>
                            </Col>
                        </Row>
                        <div className="d-flex align-items justify-content-end flex-wrap mt-sm-4 mt-3">
                            <Button variant="light" className="min-135 me-3" onClick={handleClose}>Cancel</Button>
                            <Button variant="primary" className="min-135" onClick={handleClose}>Save</Button>
                        </div>
                    </Form>
                </Modal.Body>
            </Modal>

            {/* AS document */}
            <Modal show={documentModal} onHide={handleClose} size="md" centered id="asDocument" className="docModal" backdrop="static">
                <Modal.Header closeButton className="align-items-start">
                    <div>
                        <Modal.Title>AS Document</Modal.Title>
                    </div>
                </Modal.Header>
                <Modal.Body>
                    <Form>
                        <Card>
                            <Card.Body className="p-30 text-center profileBox">
                                <div className="profileBox_info mb-0">
                                    <ImageElement source="profile-img.png" alt="user" />
                                    <label className="btn btn-outline-primary mx-auto mt-sm-3 mt-2  position-relative">Upload Photo<Input className="opacity-0 position-absolute top-0 right-0" type="file" /></label>
                                </div>
                            </Card.Body>
                        </Card>
                        <FormGroup className="form-group">
                            <label className="ant-label">Exp. Date<span className="text-650">*</span></label>
                            <DatePicker className="ant-input ant-input-lg datePicker-ant" />
                        </FormGroup>
                        <div className="d-flex align-items justify-content-end flex-wrap mt-sm-4 mt-3">
                            <Button variant="light" className="min-135 me-3" onClick={handleClose}>Cancel</Button>
                            <Button variant="primary" className="min-135" onClick={handleClose}>Save</Button>
                        </div>
                    </Form>
                </Modal.Body>
            </Modal>

            {/* Add Promo Code */}
            <Modal show={promoCodeModal} onHide={handleClose} size="lg" centered id="promoCode" backdrop="static">
                <Modal.Header closeButton className="align-items-start">
                    <div>
                        <Modal.Title>Add Promo Code</Modal.Title>
                    </div>
                </Modal.Header>
                <Modal.Body>
                    <Form>
                        <FormGroup className="form-group">
                            <label className="ant-label">Coupon Code<span className="text-650">*</span></label>
                            <Input size="large" placeholder="Enter Coupon Code" value="GGHS50" />
                        </FormGroup>
                        <FormGroup className="form-group">
                            <Button variant="outline-primary" className="min-135">Generate Coupon Code</Button>
                        </FormGroup>
                        <FormGroup className="form-group">
                            <label className="ant-label">Message</label>
                            <TextArea size="large" rows={5} placeholder="Message" maxLength={8} value=""></TextArea>
                        </FormGroup>
                        <div className="d-flex align-items justify-content-end flex-wrap mt-sm-4 mt-3">
                            <Button variant="light" className="min-135 me-3" onClick={handleClose}>Cancel</Button>
                            <Button variant="primary" className="min-135" onClick={handleClose}>Send</Button>
                        </div>
                    </Form>
                </Modal.Body>
            </Modal>

            {/*Question Modal */}
            <Modal show={questionModal} onHide={handleClose} size="lg" centered id="promoCode" backdrop="static">
                <Modal.Header closeButton className="align-items-start">
                    <div>
                        <Modal.Title>Have a Question?</Modal.Title>
                    </div>
                </Modal.Header>
                <Modal.Body>
                    <Form>
                        <FormGroup className="form-group">
                            <label className="ant-label">Message</label>
                            <TextArea size="large" rows={5} placeholder="Message" maxLength={8} value=""></TextArea>
                        </FormGroup>
                        <div className="d-flex align-items justify-content-end flex-wrap mt-sm-4 mt-3">
                            <Button variant="light" className="min-135 me-3" onClick={handleClose}>Cancel</Button>
                            <Button variant="primary" className="min-135" onClick={handleClose}>Send</Button>
                        </div>
                    </Form>
                </Modal.Body>
            </Modal>

            {/*Profile Picture Modal */}
            <Modal show={profileModal} onHide={handleClose} size="ms" centered id="profile" className="docModal" backdrop="static">
                <Modal.Header closeButton className="align-items-start">
                    <div>
                        <Modal.Title>Profile Picture</Modal.Title>
                    </div>
                </Modal.Header>
                <Modal.Body>
                    <Form>
                        <Card className="mb-0">
                            <Card.Body className="p-30 text-center profileBox">
                                <div className="profileBox_info mb-0">
                                    <ImageElement source="profile-img.png" alt="user" />
                                    <label className="btn btn-outline-primary mx-auto mt-sm-3 mt-2  position-relative">Upload Photo<Input className="opacity-0 position-absolute top-0 right-0" type="file" /></label>
                                </div>
                            </Card.Body>
                        </Card>
                        <div className="d-flex align-items justify-content-end flex-wrap mt-sm-4 mt-3">
                            <Button variant="light" className="min-135 me-3" onClick={handleClose}>Cancel</Button>
                            <Button variant="primary" className="min-135" onClick={handleClose}>Save</Button>
                        </div>
                    </Form>
                </Modal.Body>
            </Modal>

            {/*Edit Address Modal */}
            <Modal show={editaddressModal} onHide={handleClose} size="lg" centered id="editaddress" backdrop="static">
                <Modal.Header closeButton className="align-items-start">
                    <div>
                        <Modal.Title>Edit Address</Modal.Title>
                    </div>
                </Modal.Header>
                <Modal.Body>
                    <Form>
                        <FormGroup className="form-group">
                            <label className="ant-label">Location<span className="text-650">*</span></label>
                            <Select size="large" className="w-100" placeholder="Indore"
                                options={[
                                    {
                                        value: '1',
                                        label: 'Indore',
                                    },
                                    {
                                        value: '2',
                                        label: 'Indore',
                                    },
                                ]}
                            />
                        </FormGroup>
                        <FormGroup className="form-group">
                            <label className="ant-label">Country<span className="text-650">*</span></label>
                            <Select size="large" className="w-100" placeholder="India"
                                options={[
                                    {
                                        value: '1',
                                        label: 'India',
                                    },
                                    {
                                        value: '2',
                                        label: 'Srilanka',
                                    },
                                    {
                                        value: '3',
                                        label: 'Test SJ',
                                    },
                                    {
                                        value: '4',
                                        label: 'United States',
                                    }
                                ]}
                            />
                        </FormGroup>
                        {/* <FormGroup className="form-group">
                            <Input size="large" placeholder="Enter Location" value="Indore" />
                            <label className="ant-label">Location<span className="text-650">*</span></label>
                        </FormGroup>
                        <FormGroup className="form-group">
                            <Input size="large" placeholder="Enter Coupon Code" value="India" />
                            <label className="ant-label">Country<span className="text-650">*</span></label>
                        </FormGroup> */}
                        <div className="d-flex align-items justify-content-end flex-wrap mt-sm-4 mt-3">
                            <Button variant="light" className="min-135 me-3" onClick={handleClose}>Cancel</Button>
                            <Button variant="primary" className="min-135" onClick={handleClose}>Save</Button>
                        </div>
                    </Form>
                </Modal.Body>
            </Modal>

            {/*Edit Password Modal */}
            <Modal show={editpswModal} onHide={handleClose} size="lg" centered id="editaddress" backdrop="static">
                <Modal.Header closeButton className="align-items-start">
                    <div>
                        <Modal.Title>Edit Password</Modal.Title>
                    </div>
                </Modal.Header>
                <Modal.Body>
                    <Form>
                        <FormGroup className="form-group">
                            <label className="ant-label">Current Password<span className="text-650">*</span></label>
                            <div className="position-relative">
                                <Input type={password} size="large" placeholder="Enter Current Password" value="Indore" />
                                <Link className=" input-icon">         
                                    <i onClick={Eye} className={`fa ${eye ? "gg-eye-off" : "gg-eye-on" }`}></i>
                                </Link>
                            </div>
                        </FormGroup>
                        <FormGroup className="form-group">
                            <label className="ant-label">New Password<span className="text-650">*</span></label>
                            <div className="position-relative">
                                <Input type={password2} size="large" placeholder="Enter New Password" value="Indore" />
                                <Link className=" input-icon">         
                                    <i onClick={Eye2} className={`fa ${eye2 ? "gg-eye-off" : "gg-eye-on" }`}></i>
                                </Link>
                            </div>
                        </FormGroup>
                        <FormGroup className="form-group">
                            <label className="ant-label">Confirm New Password<span className="text-650">*</span></label>
                            <div className="position-relative">
                                <Input type={password3} size="large" placeholder="Enter Confirm New Password" value="Indore" />
                                <Link className=" input-icon">         
                                    <i onClick={Eye3} className={`fa ${eye3 ? "gg-eye-off" : "gg-eye-on" }`}></i>
                                </Link>
                            </div>
                        </FormGroup>
                        <div className="d-flex align-items justify-content-end flex-wrap mt-sm-4 mt-3">
                            <Button variant="light" className="min-135 me-3" onClick={handleClose}>Cancel</Button>
                            <Button variant="primary" className="min-135" onClick={handleClose}>Save</Button>
                        </div>
                    </Form>
                </Modal.Body>
            </Modal>

            {/*Bank Details Modal */}
            <Modal show={bookdetailModal} onHide={handleClose} size="lg" centered id="bookdetail" backdrop="static">
                <Modal.Header closeButton className="align-items-start">
                    <div>
                        <Modal.Title>Bank Details</Modal.Title>
                    </div>
                </Modal.Header>
                <Modal.Body>
                    <Form>
                        <FormGroup className="form-group">
                            <label className="ant-label">Payment Email<span className="text-650">*</span></label>
                            <Input size="large" placeholder="Enter Payment Email" value="payment@mail.com" />
                        </FormGroup>
                        <FormGroup className="form-group">
                            <label className="ant-label">Bank Account Holder Name</label>
                            <Input size="large" placeholder="Enter Bank Account Holder Name" value="Rose Smith" />
                        </FormGroup>
                        <FormGroup className="form-group">
                            <label className="ant-label">Account Number</label>
                            <Input size="large" placeholder="Enter Account Number" value="4875-8547-8548-854" />
                        </FormGroup>
                        <FormGroup className="form-group">
                            <label className="ant-label">Bank Name</label>
                            <Input size="large" placeholder="Enter Bank Name" value="Bank Name" />
                        </FormGroup>
                        <FormGroup className="form-group">
                            <label className="ant-label">Bank Location</label>
                            <Input size="large" placeholder="Enter Bank Location" value="India" />
                        </FormGroup>
                        <FormGroup className="form-group">
                            <label className="ant-label">BIC/SWIFT Code</label>
                            <Input size="large" placeholder="Enter BIC/SWIFT Code" value="5689696" />
                        </FormGroup>
                        <div className="d-flex align-items justify-content-end flex-wrap mt-sm-4 mt-3">
                            <Button variant="light" className="min-135 me-3" onClick={handleClose}>Cancel</Button>
                            <Button variant="primary" className="min-135" onClick={handleClose}>Save</Button>
                        </div>
                    </Form>
                </Modal.Body>
            </Modal>
        </>
    );
}
export default StoreProfile;